import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useTenant } from "@/lib/tenant";
import { PageHeader, Panel, Empty } from "@/components/Bits";

const verdictCls = {
  allow: "border-emerald-800 text-emerald-400",
  block: "border-red-900 text-red-400",
  suspicious: "border-orange-900 text-orange-400",
};

export default function Network() {
  const { tenantId } = useTenant();
  const { data = [] } = useQuery({
    queryKey: ["network", tenantId],
    queryFn: () => api.get(`/network/${tenantId}`).then((r) => r.data),
    enabled: !!tenantId,
  });

  if (!tenantId) return <Empty msg="Select an MSP tenant" />;

  return (
    <>
      <PageHeader title="Network" kicker="DNS · Outbound flows · C2 detection" />
      <div className="p-6">
        <Panel>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b hairline">
                  <th className="px-4 py-3">Time</th>
                  <th className="px-3 py-3">Source</th>
                  <th className="px-3 py-3">Destination</th>
                  <th className="px-3 py-3">Geo</th>
                  <th className="px-3 py-3">Port/Proto</th>
                  <th className="px-3 py-3">Bytes</th>
                  <th className="px-3 py-3">Verdict</th>
                </tr>
              </thead>
              <tbody>
                {data.map((f) => (
                  <tr key={f.id} className="border-b hairline hover:bg-white/[0.03]">
                    <td className="px-4 py-2.5 font-mono text-[10px] text-zinc-500">{new Date(f.ts).toLocaleString()}</td>
                    <td className="px-3 py-2.5 font-mono text-xs">{f.src}</td>
                    <td className="px-3 py-2.5 font-mono text-xs">{f.dst}</td>
                    <td className="px-3 py-2.5 font-mono text-[10px] uppercase tracking-widest text-zinc-400">{f.dst_country}</td>
                    <td className="px-3 py-2.5 font-mono text-xs">{f.port}/{f.proto}</td>
                    <td className="px-3 py-2.5 font-mono text-xs text-zinc-400">{f.bytes.toLocaleString()}</td>
                    <td className="px-3 py-2.5">
                      <span className={`font-mono text-[10px] px-1.5 py-0.5 border ${verdictCls[f.verdict]} uppercase tracking-widest`}>{f.verdict}</span>
                    </td>
                  </tr>
                ))}
                {data.length === 0 && <tr><td colSpan={7}><Empty /></td></tr>}
              </tbody>
            </table>
          </div>
        </Panel>
      </div>
    </>
  );
}
